(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-title-controller"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__senkelsCollectionTitleController) {
      return;
    }

    window.__senkelsCollectionTitleController = true;

    const TITLE_SELECTOR = "[data-collection-title]";
    const MAIN_COLLECTION_SECTION_CLASS = "shopify-section--main-collection";

    const capitalize = (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

    const parseJsonAttribute = (element, attributeName) => {
      try {
        return JSON.parse(element.getAttribute(attributeName) || "{}");
      } catch (error) {
        return {};
      }
    };

    const getActiveValues = (paramName) => {
      if (!paramName) {
        return [];
      }

      return new URLSearchParams(window.location.search).getAll(paramName).filter((value) => value.length > 0);
    };

    const formatList = (values, map, lowercaseKey, connector) => {
      const mapped = values.map((value) => {
        const key = lowercaseKey ? value.toLowerCase() : value;
        return capitalize(map[key] || value);
      }).filter((value) => value.length > 0);

      if (mapped.length === 0) {
        return "";
      }

      if (mapped.length === 1) {
        return mapped[0];
      }

      if (mapped.length === 2) {
        return `${mapped[0]} ${connector} ${mapped[1]}`;
      }

      const last = mapped.pop();
      return `${mapped.join(", ")} ${connector} ${last}`;
    };

    const setTitleText = (element, text) => {
      const splitLines = element.querySelector("split-lines");
      const styledText = element.querySelector("span.text-gradient, span.text-custom, span.text-stroke");

      if (splitLines) {
        splitLines.textContent = text;

        if (splitLines.shadowRoot) {
          const inner = splitLines.shadowRoot.querySelector("span > span") || splitLines.shadowRoot.querySelector("span");

          if (inner) {
            inner.textContent = text;
          }
        }
      } else if (styledText) {
        styledText.textContent = text;
      } else {
        element.textContent = text;
      }
    };

    const titleTextFor = (element) => {
      const originalTitle = element.getAttribute("data-original-title") || element.textContent || "";
      const connector = element.getAttribute("data-connector") || "&";
      const colorParam = element.getAttribute("data-color-param");
      const formParam = element.getAttribute("data-form-param");
      const colorPosition = element.getAttribute("data-color-position") || "before";
      const allPrefix = (element.getAttribute("data-all-prefix") || "").trim();
      const formSeparator = element.getAttribute("data-form-separator") || " | ";
      let strippedTitle = element.getAttribute("data-stripped-title") || originalTitle;

      if (allPrefix && strippedTitle === originalTitle && originalTitle.toLowerCase().indexOf(`${allPrefix.toLowerCase()} `) === 0) {
        strippedTitle = originalTitle.slice(allPrefix.length + 1);
      }

      const formattedColors = formatList(
        getActiveValues(colorParam),
        parseJsonAttribute(element, "data-color-adjectives"),
        true,
        connector
      );
      const formattedForms = formatList(
        getActiveValues(formParam),
        parseJsonAttribute(element, "data-form-adjectives"),
        false,
        connector
      );

      if (formattedForms) {
        const colorTitlePart = formattedColors
          ? colorPosition === "after"
            ? `${capitalize(strippedTitle)} ${formattedColors}`
            : `${formattedColors} ${strippedTitle}`
          : capitalize(strippedTitle);

        return `${formattedForms}${formSeparator}${colorTitlePart}`;
      }

      if (formattedColors) {
        return colorPosition === "after"
          ? `${capitalize(strippedTitle)} ${formattedColors}`
          : `${formattedColors} ${strippedTitle}`;
      }

      return originalTitle;
    };

    const updateTitles = () => {
      document.querySelectorAll(TITLE_SELECTOR).forEach((element) => {
        if (element.hasAttribute("data-original-title")) {
          setTitleText(element, titleTextFor(element));
        }
      });
    };

    const isSuccessfulEvent = (event) => event.detail?.success === true;

    const updatedMainCollectionSection = (event) => {
      const sectionId = event.detail?.sectionId;
      if (!sectionId) return false;
      const section = document.getElementById(`shopify-section-${sectionId}`);
      return Boolean(section?.classList.contains(MAIN_COLLECTION_SECTION_CLASS));
    };

    document.addEventListener("facet:update:complete", (event) => {
      if (isSuccessfulEvent(event) && updatedMainCollectionSection(event)) {
        updateTitles();
      }
    });

    document.addEventListener("collection:navigation:complete", (event) => {
      if (isSuccessfulEvent(event)) {
        updateTitles();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["length-guide-modal"] && !Shopify.designMode) return;
  try {
    let lengthGuideAssetsPromise;
  let lengthGuideWarmupScheduled = false;
  const lengthGuideOpenings = new WeakMap();

  function currentLengthGuideContainer() {
    return [...document.querySelectorAll('[data-length-guide-drawer] [data-length-guide-modal]')]
      .find(container => container.isConnected && container.closest('[data-length-guide-drawer]')?.isConnected);
  }

  function canWarmLengthGuideAssets() {
    return document.readyState === 'complete' && !document.hidden && !navigator.connection?.saveData && !lengthGuideAssetsPromise;
  }

  function loadLengthGuideAssets(container) {
    if (lengthGuideAssetsPromise) return lengthGuideAssetsPromise;

    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = container.dataset.stylesheetUrl;
    const stylesReady = new Promise((resolve, reject) => {
      stylesheet.onload = resolve;
      stylesheet.onerror = () => reject(new Error('Length guide stylesheet failed to load'));
    });
    document.head.append(stylesheet);
    lengthGuideAssetsPromise = Promise.all([
      stylesReady,
      import(container.dataset.scriptUrl),
      import(container.dataset.brandSelectorUrl)
    ]).catch(error => {
      stylesheet.remove();
      lengthGuideAssetsPromise = null;
      throw error;
    });
    return lengthGuideAssetsPromise;
  }

  function warmLengthGuideAssets() {
    lengthGuideWarmupScheduled = false;
    if (!canWarmLengthGuideAssets()) return;

    const container = currentLengthGuideContainer();
    if (!container) return;

    loadLengthGuideAssets(container).catch(() => {});
  }

  function scheduleLengthGuideWarmup() {
    if (!canWarmLengthGuideAssets() || lengthGuideWarmupScheduled) return;

    lengthGuideWarmupScheduled = true;

    if (typeof window.requestIdleCallback === 'function') {
      requestIdleCallback(warmLengthGuideAssets);
    } else {
      Promise.resolve().then(warmLengthGuideAssets);
    }
  }

  async function openLengthGuide(drawer) {
    const container = drawer.querySelector('[data-length-guide-modal]');
    if (!container) return;
    const opening = {};
    lengthGuideOpenings.set(drawer, opening);
    const label = container.querySelector('.length-guide-loader-text');
    if (label) label.textContent = container.dataset.loadingText;
    container.setAttribute('aria-busy', 'true');

    try {
      const assets = await loadLengthGuideAssets(container);
      if (lengthGuideOpenings.get(drawer) !== opening || !drawer.isConnected || !drawer.hasAttribute('open')) return;
      const configScript = drawer.querySelector('[data-length-guide-config]');
      const config = JSON.parse(configScript?.textContent || 'null');
      if (!config) throw new Error('Length guide configuration is missing');
      config.brandSelector = config.brandSelector || {};
      config.brandSelector.TextBrandSelector = assets?.[2]?.TextBrandSelector;
      if (typeof config.brandSelector.TextBrandSelector !== 'function') throw new Error('Length guide brand selector failed to load');
      await window.LengthGuideModal.openDrawer(drawer, config);
    } catch (error) {
      if (lengthGuideOpenings.get(drawer) === opening && drawer.isConnected && label) {
        label.textContent = container.dataset.errorText;
      }
    } finally {
      if (lengthGuideOpenings.get(drawer) === opening) container.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('.length-guide-trigger[aria-controls]');
    if (!trigger) return;
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    const container = drawer?.querySelector('[data-length-guide-modal]');
    if (container) loadLengthGuideAssets(container).catch(() => {});
  }, { capture: true });

  document.addEventListener('dialog:after-show', event => {
    if (event.target.matches?.('[data-length-guide-drawer]')) openLengthGuide(event.target);
  });

  document.addEventListener('dialog:after-hide', event => {
    if (event.target.matches?.('[data-length-guide-drawer]')) {
      lengthGuideOpenings.delete(event.target);
      event.target.querySelector('[data-length-guide-modal]')?.removeAttribute('aria-busy');
    }
  });

  if (document.readyState === 'complete') {
    scheduleLengthGuideWarmup();
  } else {
    window.addEventListener('load', scheduleLengthGuideWarmup, { once: true });
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleLengthGuideWarmup();
  });

  document.addEventListener('product:switched', scheduleLengthGuideWarmup);

  document.querySelectorAll('[data-length-guide-drawer][open]').forEach(openLengthGuide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["volume-pricing-table"] && !Shopify.designMode) return;
  try {
    class VolumePricingTable extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      const handler = this._onDocumentEvent.bind(this);
      document.addEventListener("input", handler, { signal: this._abortController.signal });
      document.addEventListener("change", handler, { signal: this._abortController.signal });
      this._updateActiveTier();
    }

    disconnectedCallback() {
      this._abortController?.abort();
    }

    _findQuantityInput() {
      const formId = this.getAttribute("form");
      if (!formId) {
        return document.querySelector('input[name="quantity"]');
      }
      return (
        document.querySelector(`input[name="quantity"][form="${formId}"]`) ||
        document.forms[formId]?.elements?.quantity ||
        null
      );
    }

    _onDocumentEvent(event) {
      const target = event.target;
      if (!target || target.name !== "quantity") return;
      const formId = this.getAttribute("form");
      if (formId) {
        const targetForm = target.getAttribute("form") || target.form?.id;
        if (targetForm !== formId) return;
      }
      this._updateActiveTier();
    }

    _updateActiveTier() {
      const qtyInput = this._findQuantityInput();
      if (!qtyInput) return;
      const qty = parseInt(qtyInput.value, 10) || 0;
      const rows = this.querySelectorAll("tbody tr[data-minimum-quantity]");
      let activeRow = null;
      rows.forEach((row) => {
        const min = parseInt(row.getAttribute("data-minimum-quantity"), 10);
        if (qty >= min) activeRow = row;
      });
      rows.forEach((row) => row.removeAttribute("data-active"));
      if (activeRow) activeRow.setAttribute("data-active", "true");
    }
  }

  if (!window.customElements.get("volume-pricing-table")) {
    window.customElements.define("volume-pricing-table", VolumePricingTable);
  }
  } catch(e) { console.error(e); }
})();

})();
